import React, { Component } from 'react';
import { connect } from "react-redux";
import {firstLetterText,formatDateTime} from '../../lib/helper'
import TimeAgo from "react-timeago";
import turkishStrings from 'react-timeago/lib/language-strings/tr'
import buildFormatter from 'react-timeago/lib/formatters/buildFormatter'

import {
    Link
} from "react-router-dom";
@connect((store) => {
    return {
        chatprop: store.chatprop
    };
})

class ArchiveLi extends Component {

    constructor(props) {
        super(props);

    }


    render() {
        const { t } = this.props;
		const formatter = buildFormatter(turkishStrings)
		
        return (
            <Link to={"/archive/"+this.props.data.id+window.location.search}>
                <li
                    className={"user-list-item "+(this.props.data.id==this.props.selected_id ? 'active' : '')}
                     >

                    <div className="users-list-body">
                        <div>


                            <h5>{firstLetterText(this.props.data.user_name)}</h5>
                            <span className="archive-agent-name">Agent : {this.props.data.agent_name}</span>
                            <p className="last_message">
                                {this.props.data.rate_show == 1 &&
                                <React.Fragment>
                                    {typeof this.props.data.vote !== "undefined" &&
                                    <React.Fragment>
                                        {typeof this.props.data.vote.vote !== "undefined" &&
                                        <React.Fragment>
                                            {this.props.data.vote.vote == 2 &&
                                            <span className="chatVoteDown"></span>
                                            }
                                            {this.props.data.vote.vote == 1 &&
                                            <span className="chatVoteUp"></span>
                                            }
                                        </React.Fragment>
                                        }
                                    </React.Fragment>
                                    }
                                </React.Fragment>
                                }
                                {this.props.data.last_message}
                            </p>

                        </div>
                        <span className="chatLiTimer">
						{ ((Date.now() - (this.props.data.closed_time * 1000)) / 1000 / 60 / 60 / 24) >= 1 &&
							<span>{formatDateTime((this.props.data.closed_time * 1000), 0)}</span>
						}
						
						{ ((Date.now() - (this.props.data.closed_time * 1000)) / 1000 / 60 / 60 / 24) < 1 &&
							<TimeAgo formatter={formatter} now={function now(){ return (Date.now() + (60*60*3*1000)) }} date={new Date(((this.props.data.closed_time * 1000) + (60*60*3*1000)))} />
						}
						
						
						
						</span>
                    </div>
                </li>

            </Link>

        )

    }
}

export default ArchiveLi;
